import {
    Modal, ModalContent, ModalBody, ModalOverlay, ModalFooter, ModalHeader, ModalCloseButton,
    Flex, Text, HStack, Alert, AlertIcon, FormControl, Button,
    Input, FormLabel, RadioGroup, Stack, Radio,
    useDisclosure, useToast, FormErrorMessage
} from "@chakra-ui/react"
import { useEffect, useRef } from "react"
import FormInfoPreview from "../formstep3/FormInfoPreview"
import { useSelectedItemAlertContext, defaultSelectData, reload, AL_INFO } from '../../context/selectedItemAlertContext'
import SectionForm from "./SectionForm"
import { Controller, useForm } from "react-hook-form"
import {
    BsBoxArrowInDown, BsX
} from "react-icons/bs";
import { patchUpdateFormRequest } from "../../classes/FormRequest"
import { useUserContext } from "../../context/userContext"
import { toastErrDesc, toastVal } from "../../utils/toastUtils"
import SelectEmailTemplate, { EMAIL_APPROVE,DEFAULT_EMAIL_APPROVE } from "./SelectEmailTemplate"
import { useLoadingContext } from "../../context/loadingContext"

const FooterNormal = ({ close }) => {
    return (
        <Flex w="full" justify="center">
            <Button leftIcon={<BsX />} colorScheme="blue" onClick={close}>
                ปิดหน้าต่าง
            </Button>
        </Flex>
    )
}

const FooterAdmin = ({ close }) => {
    const defaultValues = { approve_result: "Reject", approver_note: "" }
    const { control, handleSubmit, watch, formState: { errors } } = useForm({ defaultValues })
    const { itemData, setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const toast = useToast()

    const onSubmit = async (data) => {

        const sendData = {
            "approve_result": data.approve_result,
            "approver_note": data.approver_note,
            "email_temp_id": data.email_temp?.value
        }

        onModalOpen()

        await patchUpdateFormRequest(itemData.id, 'approve', userData.token, sendData)
            .then(res => {
                onModalClose()
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                }))
                
                setItemData((prev) => reload(prev))
                close()
            })
            .catch(error => {
                onModalClose()
                toast(toastVal({
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }
    return (
        <Flex w="full" direction="column">
            <Alert status="warning">
                <AlertIcon />
                <Text>เฉพาะเจ้าหน้าที่</Text>
            </Alert>
            <form onSubmit={handleSubmit(onSubmit)}>
                <SectionForm header="ผลการตรวจสอบ">
                    <Flex w="full" align="start">
                        <FormControl>
                            <Controller
                                name="approve_result"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <RadioGroup {...field}>
                                        <Stack direction="row">
                                            <Radio value="Accept">ผ่าน</Radio>
                                            <Radio value="Reject">ไม่ผ่าน</Radio>
                                        </Stack>
                                    </RadioGroup>
                                )}
                            />
                        </FormControl>
                        <FormControl isInvalid={errors.approver_note} isRequired={watch("approve_result") === "Reject"}>
                            <FormLabel>เหตุผล/หมายเหตุ</FormLabel>
                            <Controller
                                name="approver_note"
                                control={control}
                                rules={{ required: watch("approve_result") === "Reject" }}
                                render={({ field }) => (<Input maxLength={200} size="sm" placeholder="เหตุผลที่ไม่ให้ผ่าน" {...field} />)}
                            />
                        </FormControl>
                    </Flex>
                </SectionForm>
                <SectionForm header="แจ้งผลทางอีเมล">
                    <Flex w="full" align="start">
                        <FormControl isInvalid={errors.email_temp} isRequired>
                            <SelectEmailTemplate control={control} mode={EMAIL_APPROVE} defaultValue={DEFAULT_EMAIL_APPROVE} isClearable={false}/>
                            <FormErrorMessage>กรุณาเลือกแบบข้อความอีเมล</FormErrorMessage>
                        </FormControl>
                    </Flex>
                </SectionForm>
                <HStack w="full" justify="center">
                    <Button leftIcon={<BsBoxArrowInDown />} colorScheme="blue" type="submit">
                        บันทึกข้อมูล
                    </Button>
                    <Button leftIcon={<BsX />} colorScheme="red" onClick={close}>
                        ยกเลิก
                    </Button>
                </HStack>
            </form>
        </Flex>
    )
}

const ModalFormInfo = ({ data, admin = false }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { setItemData } = useSelectedItemAlertContext()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_INFO && data?.id) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} size="4xl" motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>ข้อมูลแบบฟอร์มคำร้อง</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    {data?.id && <FormInfoPreview fid={data?.id} showStatus={true} final={true} showApproveStatus={true} />}
                </ModalBody>
                <ModalFooter>
                    {admin ? <FooterAdmin close={onCloseHandle} /> : <FooterNormal close={onCloseHandle} />}
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalFormInfo
